export * from './TimeClockMoveBackIcon';
export * from './TimeClockMoveBackIcon16Light';
export * from './TimeClockMoveBackIcon16Regular';
export * from './TimeClockMoveBackIcon16Solid';
export * from './TimeClockMoveBackIcon20Light';
export * from './TimeClockMoveBackIcon20Regular';
export * from './TimeClockMoveBackIcon20Solid';
export * from './TimeClockMoveBackIcon24Regular';
export * from './TimeClockMoveBackIcon24Solid';
export * from './TimeClockMoveBackIcon32Regular';
export * from './TimeClockMoveBackIcon64Regular';
